import React, {useMemo} from 'react';
import {Form, Edit, Suggestions, List} from 'components';
import {useNamedSelector} from 'helpers';

export function StrengthsSummary() {
  const options = useNamedSelector('identity.strengthSummary');
  const PassionSuggestions = useMemo(() => options.length > 0 && (props =>
    <Suggestions.List {...props}>
      { options.map(option =>
        <p key={option}>{ option }</p>
      ) }
    </Suggestions.List>
  ), []);
  return (
    <Form {...useNamedSelector('identity.form', { name: 'strengths-summary' })}>
      <List tiny-gutter>
        <List.Title>Review your list and specify your most unique qualities? The ones that had the greatest impact on your life:</List.Title>
        <Edit name="1" Suggestions={PassionSuggestions} />
        <Edit name="2" Suggestions={PassionSuggestions} />
        <Edit name="3" Suggestions={PassionSuggestions} />
        <List.Title>How is your current occupation fully utilizing your skills and talents?</List.Title>
        <Edit name="4" />
        <List.Title>How are you leveraging your strengths?</List.Title>
        <Edit name="5" />
        <List.Title>Which of your skills, talents and strengths are not being used?</List.Title>
        <Edit name="6" Suggestions={PassionSuggestions} />
        <Edit name="7" Suggestions={PassionSuggestions} />
        <Edit name="8" Suggestions={PassionSuggestions} />
        <List.Title>Please notice that sometimes you may be very good at certain activities but you are not necessarily interested or motivated to do them. The key to a joyful and satisfying life is to spend most of your time doing what you love, while leveraging your strengths and skills.</List.Title>
      </List>
    </Form>
  );
}
